import { useMemo, useState } from "react";

import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { useMaterialUIController } from "context";

import { useNavigate } from "react-router-dom";

function Employees({ employees }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const navigate = useNavigate();

  const filteredEmployees = useMemo(
    () =>
      employees.filter((employee) =>
        employee.name.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    [employees, searchQuery]
  );

  const pagedEmployees = filteredEmployees.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <MDBox>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MDTypography variant="h6" fontWeight="medium">
          Employee Information
        </MDTypography>
        <TextField
          id="search-employees"
          label="Search Employees"
          size="medium"
          sx={{
            minWidth: { xs: "100%", sm: 360 },
            "& .MuiInputBase-root": {
              backgroundColor: "rgba(76, 175, 80, 0.08)",
            },
            "& .MuiInputLabel-root": {
              fontSize: "1.2rem",
            },
          }}
          value={searchQuery}
          onChange={(event) => {
            setSearchQuery(event.target.value);
            setPage(0);
          }}
        />
      </MDBox>
      <MDButton
        variant="contained"
        color="success"
        onClick={() => {
          navigate("/setup/addemployee/");
        }}
      >
        <Icon>add</Icon>&nbsp;Add Employee
      </MDButton>
      <MDBox mt={1}>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead sx={{ display: "table-header-group", padding: 0, borderRadius: 0 }}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>GrowSafe</TableCell>
                <TableCell>CropSure ID</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pagedEmployees.map((employee) => (
                <TableRow key={employee.key} hover>
                  <TableCell>{employee.name}</TableCell>
                  <TableCell>{employee.growSafe}</TableCell>
                  <TableCell>{employee.cropSureID}</TableCell>
                  <TableCell align="right">
                    <MDButton
                      variant="text"
                      color={darkMode ? "white" : "dark"}
                      onClick={() => {
                        navigate(`/setup/employee/${employee.key}`, { state: employee });
                      }}
                    >
                      <Icon>edit</Icon>&nbsp;edit
                    </MDButton>
                  </TableCell>
                </TableRow>
              ))}
              {pagedEmployees.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No employees found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredEmployees.length}
          page={page}
          onPageChange={(_, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </MDBox>
    </MDBox>
  );
}

Employees.propTypes = {
  employees: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};

export default Employees;
